import { render } from "./ProposalResponseMatrix.vue?vue&type=template&id=060e4e06&scoped=true&ts=true"
import script from "./ProposalResponseMatrix.vue?vue&type=script&lang=ts"
export * from "./ProposalResponseMatrix.vue?vue&type=script&lang=ts"

import "./ProposalResponseMatrix.vue?vue&type=style&index=0&id=060e4e06&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-060e4e06"]])

export default __exports__